module.exports = __webpack_public_path__ + "static/media/building_design.8e64e0a3.jpg";